export { default } from './PromotionCodeDetails.container';
